import { render } from "./commonTheme.vue?vue&type=template&id=380a5019&scoped=true"
import script from "./commonTheme.vue?vue&type=script&lang=js"
export * from "./commonTheme.vue?vue&type=script&lang=js"

import "./commonTheme.vue?vue&type=style&index=0&id=380a5019&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380a5019"]])

export default __exports__